<template>
  <div class="container-fluid mar-t-70">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6  card1  ">
          <div class="row">
            <div class="col-lg-6">
              <h4 class="red">
                Profile</h4>
            </div>
            <div class="col-lg-6 text-right">
              <!-- <a href="#" class="red" data-toggle="modal" data-target=".exampleModalCenter1" data-backdrop="false">
                <font-awesome-icon icon="edit" size="1x"></font-awesome-icon>Edit</a> -->
            </div>
          </div>

          <div class="cardinner">
            <div class="row">
              <div class="col-12 mb20">
                <label>
                  Name:</label>
                <span class="spanblock">{{getUser.first_name}} {{getUser.last_name}}</span>
              </div>
              <div class="col-12 mb20">
                <label>
                  Email:</label>
                <span class="spanblock">{{getUser.email}}</span>
              </div>

            </div>
            <div class="  mar-t-30 text-center">
              <a href="#" class="add" data-toggle="modal" data-target=".exampleModalCenter" data-backdrop="false">Change Password</a>
            </div>
          </div>

          <!-- Modal For Password-->
          <div class="modal fade exampleModalCenter" id="" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title red" id="exampleModalLongTitle">Change Password</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <ValidationObserver  ref="observer" v-slot="{ invalid }"  >
        <form class="mar-t-30" @submit.prevent="changepassword()">
                    <div class="form-group">
                       <ValidationProvider rules="required" name="Old Password" v-slot="{ errors }">
                      <input type="password" class="form-control" placeholder="Old Password" v-model="oldpassword">
                      <span class="loginerror">{{ errors[0] }}</span>
            </ValidationProvider>
                    </div>
                    <div class="form-group">
                      <ValidationProvider rules="required" name="New password" v-slot="{ errors }">
                      <input type="password" class="form-control" placeholder="New Password" v-model="newpassword">
                      <span class="loginerror">{{ errors[0] }}</span>
            </ValidationProvider>
                    </div>
                    <div class="form-group">
                      <ValidationProvider rules="required" name="Confirm New Password" v-slot="{ errors }">
                      <input type="password" class="form-control" placeholder="Confirm Password" v-model="confirmpassword">
                      <span class="loginerror">{{ errors[0] }}</span>
            </ValidationProvider>
                    </div>
                    <button type="submit" class="submit text-right">Save changes</button>
                  </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal for info -->
          <div class="modal fade exampleModalCenter1" id="" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title red" id="exampleModalLongTitle">Update Info</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form @submit.prevent="updateinfo()">
                    <div class="form-group">
                      <input type="text" class="form-control" placeholder="Name" v-model="getUser.user_name">
                    </div>
                    <button type="submit" class="submit text-right">Save changes</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import {mapGetters, mapActions} from 'vuex'
  export default {
    name: 'profile',
    data() {
      return {oldpassword: '', newpassword: '', confirmpassword: ''}
    },
    computed: {
      ...mapGetters(['getUser'])
    },
    methods: {
      ...mapActions(['setUser', 'clearAll']),
      // updateinfo() {
      //   this.$http.put('/register/adminedit/' + this.getUser.reg_id, {name: this.getUser.user_name}).then((res) => {
      //     if (res.data.success === true) {
      //       this.getinfo()
      //     }
      //   })
      // },
      // getinfo() {
      //   this.$http.get('/regis/info').then((res) => {
      //     if (res.data.success === true) {
      //       this.setUser(res.data.details[0])
      //       location.reload()
      //     }
      //   })
      // },
async changepassword () {
  this.vueloaders = true
  const isValid = await this.$refs.observer.validate()
if (isValid) {
          this.vueloaders = true
          if (this.newpassword == this.confirmpassword) {
            this.$http.put("/changepwd/cpwd", {
          email: this.getUser.email,
          oldpassword: this.oldpassword,
          newpassword: this.newpassword,
          confirmpassword: this.confirmpassword
        }).then(response => {
              this.vueloaders = false
              if (response.data.success === true) {
                // this.$store.dispatch("logout")
                this.userDetails = ""
                this.token = ""
                this.clearAll()
                localStorage.removeItem("token")
                localStorage.removeItem("vuex")
                localStorage.removeItem("userDetails")
                this.$router.push("/")
              } else {
                 this.$toasted.success('Please Correct your Fields', {
                  position: 'top-right',
                  duration: 3000,
                  theme: 'outline'
                })
                this.error = response.data.message
              }
            })
          } else {
             this.$toasted.success('Please Correct your Old Password', {
              position: 'top-right',
              duration: 3000,
              theme: 'outline'
            })
            this.error = "Passwords do not match"
          }
        } else {
          console.log("if terminated")
        }
    }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/profile.vue